var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({},_vm.$listeners),[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":"","icon":"","loading":_vm.loading}},on),[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)]}}])},[(_vm.tooltip)?_c('span',[_vm._v(" "+_vm._s(_vm.tooltip)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }